import { Injectable, Inject, forwardRef } from '@angular/core';
import { Http,  Headers, Response, URLSearchParams, } from '@angular/http';
import { Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/map';
import { IKnowAuthorization, getAuthorizeToken } from '@westjetairlines/wjesd-oauth2-library';
import { environment } from  '../../../environments/environment';

@Injectable()
export class HttpService {

  private storage: Storage = localStorage;

  constructor(private http: Http,
              @Inject(forwardRef(() => getAuthorizeToken)) private authService: IKnowAuthorization) {
  }

  getdefaultHeaders() {
    var headers = new Headers();
    headers.set('Accept', "application/json");
    headers.set('Content-Type', "application/json");
    headers.set('Authorization', 'Bearer ' + this.authService.getAuthorizationHeader());
    headers.set('Id', this.storage.getItem("id_token"));

    return headers;
  }

  sendGetRequest(path, parser, params: URLSearchParams = null): Observable<any> {
    var headers = this.getdefaultHeaders();

    if (!parser) {
      return this.http.get(environment.apiEndpoint + path, { headers: headers, search: params }).map((res: Response) => { return res; });
    }
    else {
      return this.http.get(environment.apiEndpoint + path, { headers: headers, search: params }).map((res: Response) => {
        return parser(res.json());
      });
    }
  }

  sendPostRequest(path, data, parser) {
    var headers = this.getdefaultHeaders();

    if (!parser) {
      return this.http.post(environment.apiEndpoint + path, data, { headers: headers }).map((res: Response) => { return res.json(); });
    }
    else {
      return this.http.post(environment.apiEndpoint + path, data, { headers: headers }).map((res: Response) => { return parser(res.json()); });
    }
  }

  sendPutRequest(path, data, parser) {
    var headers = this.getdefaultHeaders();

    if (!parser) {
      return this.http.put(environment.apiEndpoint + path, data, { headers: headers }).map((res: Response) => { return res.json(); });
    }
    else {
      return this.http.put(environment.apiEndpoint + path, data, { headers: headers }).map((res: Response) => { return parser(res.json()); });
    }
  }

  sendDeleteRequest(path, parser) {
    var headers = this.getdefaultHeaders();

    if (!parser) {
      return this.http.delete(environment.apiEndpoint + path, { headers: headers }).map((res: Response) => { return res.json(); });
    }
    else {
      return this.http.delete(environment.apiEndpoint + path, { headers: headers }).map((res: Response) => { return parser(res.json());
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http.service.ts